module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson4/modals/lesson_4_5_b.pdf";